import React from "react";
import { useTranslation } from "react-i18next";

import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import "./styles.less";

export const PayNewsPage = () => {
  const { t } = useTranslation();
  const news = [
    {
      title: t("common.news.news1.title"),
      text: t("common.news.news1.text"),
    },
    {
      title: t("common.news.news2.title"),
      text: t("common.news.news2.text"),
    },
    {
      title: t("common.news.news3.title"),
      text: t("common.news.news3.text"),
    },
    {
      title: t("common.news.news4.title"),
      text: t("common.news.news4.text"),
    },
  ];

  return (
    <div className="pay-news">
      <Header mode="dark" />
      <div className="pay-news-content">
        <div className="headline">{t("common.news.title")}</div>
        {news.map((item) => (
          <div className="content-news-item">
            <div className="title">{item.title}</div>
            <div className="content-text-warp">
              <div className="content-text">{item.text}</div>
              <div
                className="pay-button"
                onClick={() => {
                  window.open(
                    "//files.authing.co/authing-website/authing-pay-code.jpg"
                  );
                }}
              >
                {t("common.news.pay-button")}
              </div>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};
